var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"situacao-requerimento","rota-base":"/admin/situacao-requerimento","titulo-singular":"Situação de Requerimento","campos-extras":[{"campo":"cor","label":"Cor (hex)","tipo":"string","maxLength":9,"descricao":"Ex.: #67c23a"},{"campo":"ordem","label":"Ordem","tipo":"int"}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }